<template>
  <div class="container-fluid">
    <add-management-history></add-management-history>

    <table class="table table-hover table-bordered table-template-1 my-2 text-small">
      <thead>
      <tr>
        <th>#</th>
        <th>DATE TRANSFERRED</th>
        <th>MANAGEMENT FROM</th>
        <th>MANAGEMENT TO</th>
        <th class="col-actions" style="width: 10%;">ACTION</th>
      </tr>
      </thead>

      <tbody>
      <tr v-if="isLoading">
        <td colspan="100%">
          <app-loading></app-loading>
        </td>
      </tr>
      <template v-else>
        <tr v-for="(vesselManagement, index) in vesselManagements" :key="vesselManagement.id">
          <td class="text-right">
            {{ index + 1 }}
          </td>
          <td class="text-center">
            <span> <span v-if="vesselManagement.date_transferred">{{
                vesselManagement.date_transferred | moment('D MMM YYYY')
                                                                  }}</span></span>
          </td>
          <td class="text-center">
            {{ vesselManagement.managementFrom }}
          </td>
          <td class="text-center">
            {{ vesselManagement.managementTo }}
          </td>

          <td class="text-center">
            <template  v-if="(isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal) && !isKline">
              <button class="btn btn-sm btn-xs btn-outline-info mr-2 font-weight-bolder"
                      data-toggle="modal"
                      data-target="#view-vessel-management"
                      @click="viewVesselManagement = vesselManagement"
              >
                <span class="fas fa-eye font-weight-bolder"></span>
                View
              </button>

              <button class="btn btn-sm btn-xs btn-danger mr-2 font-weight-bolder"
                      title="Delete This Management record"
                      @click="confirmDeleteVesselManagement(vesselManagement.id)"
              >
                <span class="fas fa-trash"></span>
              </button>
            </template>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <edit-management-history :view-vessel-management="viewVesselManagement"></edit-management-history>
  </div>
</template>

<script>
import AppLoading from '@/components/elements/AppLoading';

import {vueAppMixin} from '@/mixins/vueAppMixin';
import {formMixin} from '@/mixins/formMixin';
import {dataMixin} from '@/mixins/dataMixin';
import {gateMixin} from '@/mixins/gateMixin';

import EditManagementHistory
  from '@/components/sub_components/master_lists/vessels/vessel_show_components/vessel-management/EditManagementHistory';
import AddManagementHistory
  from '@/components/sub_components/master_lists/vessels/vessel_show_components/vessel-management/AddManagementHistory';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'ManagementHistoryIndex',
  mixins: [vueAppMixin, formMixin, dataMixin, gateMixin],
  components: {AppLoading, AddManagementHistory, EditManagementHistory},

  data() {
    return {
      viewVesselManagement: {},
    };
  },

  methods: {
    ...mapActions([
      'getVesselManagements',
      'getManagements',
      'deleteVesselManagement',
    ]),

    async confirmDeleteVesselManagement(vesselManagementId) {
      if (await this.confirmDeleteAlert()) {
        let deleteVesselManagement = await this.deleteVesselManagement({vesselManagementId: vesselManagementId});
        if (deleteVesselManagement) this.successAlert('Vessel Management Record Successfully Deleted', 'DELETE');
      }
    },

  },

  computed: {
    ...mapGetters([
      'vesselManagements',
      'managements',
      'vesselInfo',
    ]),
  },

  created() {
    this.getManagements();
    this.getVesselManagements({vesselManagementId: this.$route.params.id});
  },

  watch: {
    // 'vesselInfo.id'() {
    //   this.getVesselManagements({vesselManagementId: this.$route.params.id});
    // },

  },

};
</script>

<style scoped>

</style>
